<template>
    <b-navbar type="is-navbar-main navbar-default" is-active centered>
        <template #brand>
            <a class="navbar-item" id="icon-sidebar" title="Abrir o menu" :class="{ 'is-hidden': sidebarIsOpened }" @click="SET_SIDEBAR(true)">
                <b-icon icon="menu"></b-icon>
            </a>

            <a class="navbar-item is-hidden-mobile" @click="$router.push(`/`)">
                <img v-if="config.logoBase64_2" :src="'data:image/png;base64, ' + config.logoBase64_2" height="20" width="80" />                
            </a>
        </template>

        <template #end>

            <div v-if="config.logoffTimer" class="navbar-item" id="navIdleProgressBar">
                <b-progress :value="idleProgressBarValue" :type="idleProgressBarType" show-value>
                    <small>{{ idleRemainingTime }}</small>
                </b-progress>
            </div>



            <a class="navbar-link is-arrowless" @click="TOGGLE_MODAL_NOTIFICACAO" title="Notificações Recebidas">
                <b-icon icon="bell"></b-icon>
                <b-tag v-if="totalNotificacao > 0" type="is-danger tag-notify" rounded>{{ totalNotificacao }}</b-tag>
            </a>            

            <a class="navbar-link is-arrowless" @click="TOGGLE_MODAL_USUARIO" title="Editar Perfil">
                <b-icon icon="account"></b-icon>
            </a>

            <b-modal :active="modalNotificacaoIsOpened" @update:active="modalNotificacaoIsOpened = $event" has-modal-card trap-focus aria-role="dialog" aria-modal>
                <modal-notificacao @close="modalNotificacaoIsOpened = false"></modal-notificacao>
            </b-modal>            

            <b-modal :active="modalUsuarioIsOpened" @update:active="modalUsuarioIsOpened = $event" has-modal-card trap-focus aria-role="dialog" aria-modal>
                <modal-usuario @close="modalUsuarioIsOpened = false"></modal-usuario>
            </b-modal>
        </template>
    </b-navbar>
</template>

<style scoped>
    .dropdown-item-custom {
        padding: 0.75rem 1rem;
        border-bottom: 1px solid #e0e0e0;
    }

    .dropdown-item-custom:last-child {
        border-bottom: none;
    }

    .dropdown-item-custom:hover {
        background-color: #f5f5f5;
    }
</style>

<script>
    import { mapState, mapGetters } from 'vuex'
    import { mapMutations } from 'vuex'
    import http from '@/http'
    import modalUsuario from '@/components/modalUsuario'
    import modalNotificacao from '@/components/modalNotificacao.vue'

    export default {
               
        components: {
            modalUsuario,
            modalNotificacao
        },
        mounted() {
            this.loadTotalNotificacoesFuncionario();              
        },        

        computed: {
          
            idleRemainingTime() {
                const totalSeconds = (this.$store.state.config.logoffMiliseconds - this.$store.state.idle.time) / 1000;

                const minutes = Math.floor(totalSeconds / 60);
                const seconds = Math.floor(totalSeconds % 3600 % 60);

                return minutes + ":" +
                    (seconds < 10 ? "0" : "") + seconds;
            },
            idleProgressBarValue() {
                const value = ((this.$store.state.config.logoffMiliseconds - this.$store.state.idle.time) / this.$store.state.config.logoffMiliseconds) * 100;
                return isNaN(value)
                    ? 100
                    : value;
            },
            idleProgressBarType() {
                return this.idleProgressBarValue > 66
                    ? "is-info"
                    : this.idleProgressBarValue > 33
                        ? "is-warning"
                        : "is-danger";
            },
            notificationsCount() {
                return 10;
            },            

            modalNotificacaoIsOpened: {
                get() {
                    return this.$store.state.componentes.modalNotificacaoIsOpened;
                },
                set(value) {
                    return this.$store.commit('componentes/SET_MODAL_NOTIFICACAO', value)
                }
            },  
            totalNotificacao:{
                get() {
                    return this.$store.state.componentes.totalNotificacao;
                },
                set() {
                    return this.$store.commit('componentes/SET_TOTAL_NOTIFICACAO',0)
                }                

            },         
            totalMensagens:{
                get() {
                    return this.$store.state.componentes.totalMensagens;
                },
                set() {
                    return this.$store.commit('componentes/SET_TOTAL_MENSAGENS',0)
                }                

            },             
            modalUsuarioIsOpened: {
                get() {
                    return this.$store.state.componentes.modalUsuarioIsOpened;
                },
                set(value) {
                    return this.$store.commit('componentes/SET_MODAL_USUARIO', value)
                }
            },
            ...mapState([
                'config',
                'usuario'
            ]),
            ...mapGetters([
                'isInRole'
            ]),
            ...mapState('componentes', [
                'sidebarIsOpened'
            ])
        },
        methods: {
            loadTotalNotificacoesFuncionario() {
                
                http.get('/api/notificacao/retornaTotalNotificacoesFuncionario?funcionarioId=' + this.usuario.funcionarioId )
                        .then(res => res.data)
                        .then(data => {   
                        
                        this.$store.commit('componentes/SET_TOTAL_NOTIFICACAO',data)
                    })
                    .catch((error) => {                        
                        throw error
                    });


                http.get('/api/notificacao/RetornaTotalMensagensFuncionario?funcionarioId=' + this.usuario.funcionarioId )
                        .then(res => res.data)
                        .then(data => {   
                        
                            this.$store.commit('componentes/SET_TOTAL_MENSAGENS',data)
                        
                    })
                    .catch((error) => {                        
                        throw error
                    });                       
                
            },             
            ...mapMutations('componentes', [
                'SET_SIDEBAR',
                'TOGGLE_MODAL_USUARIO',
                'TOGGLE_MODAL_NOTIFICACAO',
                'SET_TOTAL_NOTIFICACAO',
                'SET_TOTAL_MENSAGENS'
            ]),
            redirectTo(page){
                this.$router.push({ name: page});
            }

        }
    }
</script>
